import React from 'react'
import { bool, node, string } from 'prop-types'
import './style.scss'

export const SlideToggleContent = ({ isOpen, className, wise, children }) => {
  return !wise || wise === 'bottom' ? (
    <div
      className={`slide-container slide-bottom-container ${
        isOpen ? 'slide-bottom-open' : 'slide-bottom-close'
      } ${className}`}
    >
      {children}
    </div>
  ) : (
    <div
      className={`slide-container slide-top-container ${isOpen ? 'slide-top-open' : 'slid-tope-close'} ${className}`}
    >
      {children}
    </div>
  )
}

SlideToggleContent.displayName = 'SlideToggleContent'

SlideToggleContent.propTypes = {
  isOpen: bool.isRequired,
  className: string,
  wise: string,
  children: node.isRequired
}

SlideToggleContent.defaultProps = {
  isOpen: true,
  className: '',
  wise: 'bottom'
}
